/**
 * LockMenu — hamburger ↔ Zelda rupee toggle icon.
 *
 *   • Closed: classic 3-thick-line hamburger.
 *   • Open:   the 3 lines first converge to the centre, then lift up and
 *             off the icon (like a lock being released), revealing a
 *             chunky green Zelda rupee gem underneath.
 *
 * Pure SVG + CSS transitions, no animation library required.
 */
const LockMenu = ({ open = false, size = 32, className = '', 'data-testid': testId }) => {
  const w = size;
  const h = size;
  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={`lock-menu ${open ? 'open' : 'closed'} ${className}`}
      data-testid={testId}
    >
      {/* Hidden by default; revealed when the lines lift off */}
      <g className="lock-rupee">
        {/* Outer hexagonal gem body — classic green rupee */}
        <path
          d="M 24 5 L 38 17 L 38 31 L 24 43 L 10 31 L 10 17 Z"
          fill="#3DD12F"
          stroke="#0A0A2E"
          strokeWidth="2.5"
          strokeLinejoin="round"
        />
        {/* Inner facet outline — gives it that Zelda-gem cut look */}
        <path
          d="M 24 11 L 33 18 L 33 30 L 24 37 L 15 30 L 15 18 Z"
          fill="none"
          stroke="#1C8F19"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        {/* Lighter highlight slab on the upper-left facet */}
        <path
          d="M 24 11 L 18 16 L 15 18 L 15 24 L 12 22 L 12 18 L 16 14 L 21 11 Z"
          fill="#A6F0A0"
          opacity="0.85"
        />
        {/* Sparkle */}
        <circle cx="19" cy="15" r="1.2" fill="#FFFFFF" />
      </g>

      {/* The 3-line "lock" — converges, then lifts off */}
      <g className="lock-bars">
        <rect className="lock-line lock-line-top" x="6"  y="12" width="36" height="4" rx="1.5" fill="#0A0A2E" />
        <rect className="lock-line lock-line-mid" x="6"  y="22" width="36" height="4" rx="1.5" fill="#0A0A2E" />
        <rect className="lock-line lock-line-bot" x="6"  y="32" width="36" height="4" rx="1.5" fill="#0A0A2E" />
      </g>
    </svg>
  );
};

export default LockMenu;
